var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "btn btn-link",
      attrs: { to: { name: "privacy-policy" }, target: "_blank" }
    },
    [
      _vm._v("\n  " + _vm._s(_vm.$t("PrivacyPolicy")) + "\n  "),
      _c("span", { staticClass: "sr-only" }, [
        _vm._v(_vm._s(_vm.$t("NewWindow")))
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "fas fa-external-link-alt" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }